import baseURL from '.'

const BUS = `${baseURL}bus/`

export const URL = {
  system: () => `${BUS}system`
}
